import { globalVariables } from "helper/globalVariables";
import { filterUniqueLevels } from "helper/utils";
import { useMemo } from "react";

export const TrailTitle = ({ host }) => {
  return (
    <div>
      <div className="flex gap-2">
        <div className="w-[50px]">
          <span className="text-gray-700 font-sans text-[16px] font-[500] leading-6">
            {`${globalVariables.host}:`}
          </span>
        </div>
        <span className="text-gray-700 font-sans text-[16px] font-[500] leading-6">
          {host}
        </span>
      </div>
    </div>
  );
};
